import React, { useState } from "react";
export const UserProvider = React.createContext();

export const AppProvider = ({ children }) => {
  let cookieLocal = localStorage.getItem("language");
  const [userData, setUserData] = useState(null);
  const [language, setLanguage] = useState(cookieLocal ? cookieLocal : "en");

  const changeLanguage = (v) => {
    localStorage.setItem("language", v);
    let cookie = localStorage.getItem("language");

    setLanguage(cookie);
  };

  return (
    <UserProvider.Provider
      value={{
        userData,
        setUserData,
        language,
        changeLanguage,
      }}
    >
      {children}
    </UserProvider.Provider>
  );
};
